var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-wrapper" }, [
    _c(
      "video",
      {
        ref: "video",
        attrs: { playsinline: "", autoplay: "", muted: "" },
        domProps: { muted: true }
      },
      [
        _c("source", { attrs: { src: _vm.videoWebm, type: "video/webm" } }),
        _vm._v(" "),
        _c("source", { attrs: { src: _vm.videoMp4, type: "video/mp4" } })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }